/* Only augments the native cart: Shopify and the theme handle totals and quantity changes. */
document.addEventListener('click',function(event){
  const link=event.target.closest('#CartDrawer .cart__remove a');
  if(!link)return;
  const row=link.closest('.cart__item');
  const input=row&&row.querySelector('.js-qty__num');
  if(!input)return;
  event.preventDefault();
  input.value=0;
  input.dispatchEvent(new Event('change',{bubbles:true}));
});
